import { Get } from './index'

// 查询文章详情
export const getArticle = id => Get(`/article/${id}`)
// 查询文章列表
export const getArticleList = Get('/article/list')
// 获取文章资源数据
export const getArticleResource = (id) => Get(`/article/resource/auth_code/${id}`)
